import React from "react";
import "./Back_arrow_holder.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";

function Back_arrow_holder({ onClick }) {
  return (
    <>
      <div className="back-arrow-holder" onClick={onClick}>
        <FontAwesomeIcon className="back-icon" icon={faAngleLeft} />
      </div>
    </>
  );
}

export default Back_arrow_holder;
